<section class="index-banner-inner pad" style="background-image: url(assets/images/Reg_form.jpg);">
	<div class="container-fluid">
		<div class="container">
			<h2 class="title-banner mbtm20">Clients </h2>
		</div>
	</div>
</section>

<section class="pricing-area">
	<div class="container">
		<div class="row mt2em">
			<div class="col-md-12">
				<h2 class="text-center"><br/><br/><br/>
					<span>Coming Soon</span><br/><br/><br/><br/>
				</h2>
			</div>
		</div>
	</div>
</section>
